<template>
  <v-app>
    <alert-component></alert-component>

    <!-- Sidebar -->
    <app-sidebar
        v-if="isAuthenticated"
        drawer="drawer"
        class="elevation-2"
        style="background-color: #ffffff"
    />

    <!-- Header -->
    <app-header
        v-if="isAuthenticated"
        class="elevation-2"
        color="primary"
        dark
    />

    <!-- Контент -->
    <v-main style="background-color: #ecf1f6">
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>


<script>

import AlertComponent from "@/components/AlertComponent";
import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
export default {
  name: 'App',

  components: {
    AppSidebar,
    AppHeader,
    AlertComponent
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters["auth/isAuthenticated"]
    }
  },
  data: () => ({
    drawer: true,
  }),
  methods: {
    drawerChange () {
      this.drawer = !this.drawer
    }
  }
};
</script>

<style>
.card {
  margin: 10px;
  padding: 30px;
  height: 100%;
}
.top-bar {
  z-index: 4;
  left: 0;
}
</style>
